import { SlotEventConstantsBehavior, SoundConstant, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import { ReSpinIntroOutroController } from "../Controller/ReSpinIntroOutroController";
import { ReSpinIntroOutroView } from "../View/ReSpinIntroOutroView";
import { gameConstants } from "../../Constants/gameConstants";
import { HoldAndRespinView } from "../View/HoldAndRespinView";
import { HoldAndRespinModel } from "../Model/HoldAndRespinModel";
import { GameParserModel } from "../../Platform/GameParserModel";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { HoldAndReSpinController } from "../Controller/HoldAndReSpinController";
import { HoldAndRespinReelPanelController } from "../ReelPanel/HoldAndRespinReelPanelController";
import { AutoPilotBaitController } from "../Controller/AutoPilotBaitController";
import { ReSpinCounterController } from "../Controller/ReSpinCounterController";
import { BigFishController } from "../Controller/BigFishController";
import { WinCollectionTrailController } from "../Controller/WinCollectionTrailController";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";

export class FishingTimeHoldAndRespinLogic {
  private readonly sequenceArray: string[];
  private readonly spinFlowSequenceArray: string[];
  private sequenceCounter: number = 0;
  private spinFlowCounter: number = 0;
  private holdAndRespinController: HoldAndReSpinController;
  private holdAndRespinView: HoldAndRespinView;
  private model: HoldAndRespinModel;
  private reSpinReelPanel: HoldAndRespinReelPanelController;
  private reSpinIntroOutroController: ReSpinIntroOutroController;
  private reSpinIntroOutroView: ReSpinIntroOutroView;
  private movingBaitController: AutoPilotBaitController;
  private bigFishController: BigFishController;
  private CollectionTrailController: WinCollectionTrailController;
  private reSpinCounterController: ReSpinCounterController;
  constructor() {
    this.sequenceArray = ["ReSpinIntro", "Spinning", "ShowJackpots", "showWinningTrail", "ShowYouWon", "showTrailToCollection", "RevealCollection", "resetAndSendClose"];
    this.spinFlowSequenceArray = ["autoPilotBaitLanded", "showLargeFish", "autoSpinClicked"];
    this.init();
    this.subscribeEvents();
  }
  /**
   * Initialize lightning bonus feature classes
   */
  private init(): void {
    this.initializeHoldAndReSpinReelModel();
    this.initializeHoldAndReSpinController();
    this.initializeHoldAndRespinReelPanel();
    this.initializeReSpinCounterController();
    this.initializeRespinIntroOutro();
  }
  //sunscribe feature events
  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION, this.onShowNextFeaturePresentation, this);
    dispatcher.on(eventDispatchers.SEND_NEXT_SPIN_FLOW, this.showNextSpinFlow, this);
  }
  /**
   * unsubscribe all events
   */
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION, this.onShowNextFeaturePresentation, this);
    dispatcher.off(eventDispatchers.SEND_NEXT_SPIN_FLOW, this.showNextSpinFlow, this);
  }
  /**
   * function to initialize respin intro outro view and controller
   */
  private initializeRespinIntroOutro(): void {
    if (!this.reSpinIntroOutroController && !this.reSpinIntroOutroView) {
      this.reSpinIntroOutroView = new ReSpinIntroOutroView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).reSpinIntroOutro
      );
      this.reSpinIntroOutroController = new ReSpinIntroOutroController(this.reSpinIntroOutroView);
    }
  }
  //initialize model
  private initializeHoldAndReSpinReelModel() {
    if (!this.model) {
      this.model = new HoldAndRespinModel();
      this.model.json = ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).holdAndReSpinReels;
    }
  }
  // initiallize ReelPanel
  private initializeHoldAndRespinReelPanel(): void {
    if (!this.reSpinReelPanel) {
      this.reSpinReelPanel = new HoldAndRespinReelPanelController(ingenuity.currentGame, this.model);
      this.holdAndRespinView.setReelView(this.reSpinReelPanel);
    }
    this.reSpinReelPanel.init(this.model.showInitialGrid());
    dispatcher.fireEvent(SlotEventConstants.REEL_MASK_ON);
    dispatcher.fireEvent(SlotEventConstants.REEL_MASK_ON);
  }
  //initialize controller
  private initializeHoldAndReSpinController() {
    if (!this.holdAndRespinController && !this.holdAndRespinView) {
      this.holdAndRespinView = new HoldAndRespinView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).HoldAndRespin
      );
      this.holdAndRespinController = new HoldAndReSpinController(this.holdAndRespinView, this.model);
    }
    ingenuity.currentGame.stage.addChild(this.holdAndRespinView);
  }
  // inititalize respin counter
  private initializeReSpinCounterController() {
    this.reSpinCounterController = new ReSpinCounterController(this.holdAndRespinView);
  }
  /**
   * Method to updates presentation sequence counter
   */
  private updateSequenceCounter(): void {
    this.sequenceCounter += 1;
  }
  /**
   * Method to show next Feature presentation in sequence
   */
  private onShowNextFeaturePresentation(): void {
    const currentWinEventToShow: string = this.sequenceArray[this.sequenceCounter];
    this.updateSequenceCounter();
    switch (currentWinEventToShow) {
      case "ReSpinIntro":
        this.showReSpinIntro();
        break;
      case "Spinning":
        this.onStartReelSpinning();
        break;
      case "ShowJackpots":
        this.onShowJackpotOnReel();
        break;
      case "showWinningTrail":
        this.showWinningTrail();
        break;
      case "ShowYouWon":
        this.showYouWonOutro();
        break;
      case "showTrailToCollection":
        this.showTrailToCollection();
        break;
      case "RevealCollection":
        this.onRevealCollection();
        break;
      case "resetAndSendClose":
        this.resetFeatureSendClose();
        break;
    }
  }
  //     /**
  //      * to show respin intro
  //      */
  private showReSpinIntro(): void {
    dispatcher.fireEvent(eventDispatchers.START_RESPIN_INTRO);
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.FISH_TIME_INTRO_BLURBG_SHOW);

    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    }
  }
  /**
   * to show reel spinning
   */
  private onStartReelSpinning(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      ingenuity.configData.isReelSpinMusicPlaying = false;
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.BASEGAME_BGMLOOP });
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.MUSIC_SPIN });
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, {
        id: SoundConstant.FREGAME_BGLOOP,
        key: "soundList_1",
      });
    }
    dispatcher.fireEvent(eventDispatchers.STOP_INITIAL_SYM_APPEREARED_REEL);
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
      id: SoundConstantGame.MUSIC_RESPIN,
      vol: 1,
      loop: true,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
    this.autoSpinClicked();
  }
  /**
   * function will send spin click call after a delay
   */
  private autoSpinClicked(): void {
    this.spinFlowCounter = 0;
    delayedCall(
      "onFeatureSpinCompleted",
      1300,
      () => {
        killDelayedCall("onFeatureSpinCompleted");
        this.onSpinInitiated();
      },
      this
    );
  }
  /**
   * called when next spin initiated
   */
  private onSpinInitiated(): void {
    if (
      (ingenuity.parserModel as GameParserModel).getCurrentReSpinIndex() <
      (ingenuity.parserModel as GameParserModel).getFishingTimeTotalCount()
    ) {
      this.model.setTotalStoppedReels(this.model.getStoppedReels().length);
      dispatcher.fireEvent(eventDispatchers.PARSE_NEXT_HOLD_AND_RESPIN_DATA);
      this.model.increaseReSpinCount();
      dispatcher.fireEvent(eventDispatchers.REMOVE_ANTICIPATION_CONT);
      dispatcher.fireEvent(eventDispatchers.START_TV_REEL_SPINNING);
      if (this.model.getTotalStoppedReels() >= 37) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
          id: SoundConstantGame.LAST_REEL_SOUND_RESPIN,
          vol: 1,
          loop: false,
          key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
        });
        this.checkForAnticipation();
      }


      //
      delayedCall(
        "reelStopDelay",
        300,
        () => {
          killDelayedCall("reelStopDelay");
          dispatcher.fireEvent(eventDispatchers.STOP_TV_REEL, this.model.getStoppingGrid());
        },
        this
      );
      dispatcher.fireEvent(eventDispatchers.UPDATE_SPIN_REMAINING_COUNT);
    } else {
      this.onShowNextFeaturePresentation();
    }
  }
  private checkForAnticipation():void{
    for(let i = 0 ; i<this.model.numOfReels ;i++){
      if(!this.model.getStoppedReels().includes(i)){
        dispatcher.fireEvent(eventDispatchers.PLAY_ANTICIPATION_ON_TV_REELS,i)
      }
    }
  }
  /**
   * to show jackpot data in reels
   */
  private onShowJackpotOnReel(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsJackpotAvailable()) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_JACKPOT);
      dispatcher.fireEvent(eventDispatchers.SHOW_JP_PRESENTATION);
    } else {
      this.onShowNextFeaturePresentation();
    }
  }
  private showWinningTrail(): void {
    this.initializeCollectionTrailController();
    if ((ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin() > 0) {
      dispatcher.fireEvent(eventDispatchers.SHOW_WIN_COLLECTION_TRAIL);
      dispatcher.fireEvent(eventDispatchers.COLLECT_BIG_FISH);
    } else {
      this.onShowNextFeaturePresentation();
    }
  }
  //initialize trial controller
  private initializeCollectionTrailController(): void {
    if (!this.CollectionTrailController) {
      this.CollectionTrailController = new WinCollectionTrailController(this.holdAndRespinView, this.model);
    }
  }
  /**
   * to show respin outro
   */
  private showYouWonOutro(): void {
    ingenuity.currentGame.stage.addChild(this.reSpinIntroOutroView);
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, {
      id: SoundConstantGame.MUSIC_RESPIN,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
    dispatcher.fireEvent(eventDispatchers.START_RESPIN_OUTRO);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.FISH_TIME_OUTRO_BLURBG_SHOW);
  }
  //starting point for trail from fish to collection
  private showTrailToCollection(): void {
    if ((ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin() > 0) {
      dispatcher.fireEvent(eventDispatchers.SHOW_TRAIL_TO_COLLECTION);
    } else {
      this.onShowNextFeaturePresentation();
    }
  }
  /**
   * to show collection screen on feature end
   */
  protected onRevealCollection(): void {
    this.onShowNextFeaturePresentation();
    if ((ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin() > 0) {
      dispatcher.fireEvent(eventDispatchers.INITIALIZE_COLLECTION_SCREEN);
      dispatcher.fireEvent(eventDispatchers.UPDATE_COLLECTION_PAYOUT);
      dispatcher.fireEvent(eventDispatchers.REVEAL_COLLECTION_AFTER_HNR);
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_AFTER_BIGWIN);
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    }
  }
  /**
   * to handle flow between spins
   */
  private showNextSpinFlow(): void {
    const currentWinEventToShow: string = this.spinFlowSequenceArray[this.spinFlowCounter];
    this.updateSpinFlowCounter();
    switch (currentWinEventToShow) {
      case "autoPilotBaitLanded":
        this.showMovingBait();
        break;
      case "showLargeFish":
        this.showLargeFish();
        break;
      case "autoSpinClicked":
        this.autoSpinClicked();
        break;
    }
  }
  // to update sequence counter
  private updateSpinFlowCounter(): void {
    this.spinFlowCounter += 1;
  }
  // starting point for moving bait symbol
  private showMovingBait(): void {
    if ((ingenuity.parserModel as GameParserModel).getPositionBaitPosition().length > 0) {
      this.initializeMovingBaitController();
      dispatcher.fireEvent(eventDispatchers.MOVE_AUTO_PILOT_BAIT);
    } else {
      this.showNextSpinFlow();
    }
  }
  //initialize moving bait controller
  private initializeMovingBaitController(): void {
    if (!this.movingBaitController) {
      this.movingBaitController = new AutoPilotBaitController(this.holdAndRespinView, this.model);
    }
  }
  // starting point for large fish on reel
  private showLargeFish(): void {
    if ((ingenuity.parserModel as GameParserModel).getIsBigFishAwarded()) {
      this.initializeBigFishController();
      dispatcher.fireEvent(eventDispatchers.SHOW_BIG_FISH);
    } else {
      this.showNextSpinFlow();
    }
  }
  // initialize big fish controller
  private initializeBigFishController(): void {
    if (!this.bigFishController) {
      this.bigFishController = new BigFishController(this.holdAndRespinView, this.model);
    }
  }
  /**
   * to reset full feature
   */
  private resetFeatureSendClose(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
        id: SoundConstant.BASEGAME_BGMLOOP,
        vol: 1,
        loop: true,
        key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
      });
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
        id: SoundConstant.FREGAME_BGLOOP,
        vol: 1,
        loop: true,
        key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
      });
    }
    ((ingenuity.parserModel as GameParserModel).getFreeSpinsRemaining() <= 0) && dispatcher.fireEvent(eventDispatchers.RESET_PROGRESS_BAR_IN_BASEGAME);
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, {
      id: SoundConstantGame.MUSIC_RESPIN,
      key: "soundList_1",
    });
    this.sequenceCounter = 0;
    this.spinFlowCounter = 0;
    this.resetControllers();
    (ingenuity.parserModel as GameParserModel).setIsHoldAndRespinAvailable(false);
    this.unSubscribeEvents();
    dispatcher.fireEvent(eventDispatchers.DESTROY_RESPIN);
  }
  //reset all controllers
  private resetControllers(): void {
    this.reSpinCounterController?.resetController();
    this.reSpinCounterController = null;
    this.reSpinIntroOutroController?.resetController();
    this.reSpinIntroOutroController = null;
    this.reSpinIntroOutroView?.destroy();
    this.reSpinIntroOutroView = null;
    this.movingBaitController?.resetController();
    this.movingBaitController = null;
    this.bigFishController?.resetController();
    this.bigFishController = null;
    this.CollectionTrailController?.resetController();
    this.CollectionTrailController = null;
    this.reSpinReelPanel?.resetRespinReelPanel();
    this.reSpinReelPanel = null;
    this.holdAndRespinController?.resetController();
    this.holdAndRespinController = null;
    this.holdAndRespinView?.resetRespinView();
    this.holdAndRespinView = null;
    this.model?.resetFeatureData();
    this.model = null;
  }
}
